import * as Styled from './styled'
import { Navbar, Menu, MobileMenuOptions } from './sections'
import { useRequest } from 'ahooks'
import { Profile, Auth } from '~services'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { trackAuthentication } from '~utils/analytics'
import { useStore } from '~hooks'
import LogoFreteBras from './sections/LogoFreteBras'

function Header() {
  const store = useStore()
  const location = useLocation()
  const [username, setUsername] = useState(localStorage.getItem('username'))
  const { data } = useRequest(Profile.me, { onSuccess: handleSuccess, onError: handleError })
  const [mobileMenu, setMobileMenu] = useState(false)
  const { runAsync } = useRequest(Auth.logout, { manual: true })
  const navigate = useNavigate()

  function handleError() {
    window.location.href = '/fretes'
  }

  function handleSuccess() {
    if (data?.id) trackAuthentication(data?.id)

    if (data?.name) {
      const [firstName] = data.name.split(' ')
      localStorage.setItem('username', firstName)
      setUsername(firstName)
    }
  }

  async function logout() {
    if (location.pathname.includes('/dados-veiculo')) {
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: async () => {
          await runAsync()
          window.location.href = '/entrar'
        },
      })
    } else {
      await runAsync()
      window.location.href = '/entrar'
    }
  }

  function handleClickBack() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({ saveVehicleDataModal: true, saveVehicleDataCallback: () => navigate(-1) })
    else navigate(-1)
  }

  function toggleMobileMenuVisibility() {
    setMobileMenu((state) => !state)
  }

  return (
    <Styled.Header role="heading" data-testid="header">
      <Styled.Wrapper>
        <Styled.Back data-testid="back-button" onClick={handleClickBack} />
        <LogoFreteBras data-testid="logo" />
        <Styled.Menu data-testid="menu-button" onClick={toggleMobileMenuVisibility} />
        <MobileMenuOptions
          username={username?.toUpperCase()}
          isVisible={mobileMenu}
          onClose={toggleMobileMenuVisibility}
          onClickLogout={logout}
        />
        <Styled.RightGroup>
          <Navbar />
          <Styled.Divisor data-testid="divisor" />
          <Menu username={username?.toUpperCase()} onClickLogout={logout} />
        </Styled.RightGroup>
      </Styled.Wrapper>
    </Styled.Header>
  )
}

export default Header
